export const config = {
  supportedCountries: [
    'nl',
    'gb',
    'fr',
    'de',
    'se',
    'dk',
    'fi',
    'no',
    'mx',
    'es',
    'it',
    'br',
  ],
  countryAliasMap: {
    ax: 'fi',
    ie: 'gb',
  },
}
